<template>
<opm-page :show-modal="showModal" @hide="showModal = false" :wx-share="wxShare">
  <ion-content>
    <swiper :slides-per-view="1" :loop="true" :autoplay="{ delay: 3000, disableOnInteraction: false}" :pagination="{ 'dynamicBullets': true }">
      <swiper-slide v-for="(photo, ind) in house.houseImages.split(',')" :key="ind">
        <ion-img :src="house.imageHost + photo"/>
      </swiper-slide>
    </swiper>
    <div class="ion-padding">
      <div class="flex-between">
        <div>
          <span class="tag" :class="ind === 0 ? 'orange' : ''" v-for="(tag, ind) in house.tags.split(',')" :key="ind">
            {{ tag }}
          </span>
        </div>
        <div>
          <ion-label style="color:grey;font-size:16px" @click="showModal = true">
            <ion-icon slot="start" :icon="starOutline"></ion-icon>
          </ion-label>
        </div>
      </div>
      <h2 style="font-weight: 600">{{ house.district }} | {{ house.address }}</h2>
      <div>
        <div style="color: red;display: inline-block">
          <span style="font-size: 12px">￥</span><span style="font-size:20px">{{ house.price }}</span><span style="font-size: 12px">万</span>
        </div>
        <div style="color: #8F93A0;margin-left: 5px; display: inline-block;font-size:12px">$ {{ house.audPrice }}万澳元</div>
      </div>
      <div style="margin-top: 16px;" class="flex-between">
        <div>
          <div class="room-title">{{ house.houseType }}</div>
          <div class="room-subtitle">户型</div>
        </div>
        <div>
          <div class="room-title">{{ house.area }}㎡</div>
          <div class="room-subtitle">面积</div>
        </div>
        <div>
          <div class="room-title">{{ $filters.dayjs(house.constructionTime, 'YYYY') }}</div>
          <div class="room-subtitle">建筑时间</div>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div><h4>房产介绍</h4></div>
        <p v-html="house.detail"></p>
      </div>
      <div style="margin-top: 30px">
        <div><h4>配套设施</h4></div>
        <div style="display: flex;flex-wrap: wrap;">
          <div v-for="(f, ind) in house.facilities.split(',')" :key="ind" style="display: flex;flex-direction: column;align-items: center;width: calc(100% / 5);margin-bottom: 20px">
            <img :src="`/assets/facilities/${f}.svg`" width="24" height="24" />
            <span style="font-size: 12px; color: #33394e;margin-top: 5px">{{ f }}</span>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px" v-if="house.floorPlans">
        <div><h4>户型介绍({{ house.floorPlans.split(',').length }})</h4></div>
        <swiper :slides-per-view="'auto'" :loop="true" :space-between="30" :autoplay="{ delay: 3000, disableOnInteraction: false}">
          <swiper-slide v-for="(photo, ind) in house.floorPlans.split(',')" :key="ind">
            <ion-img :src="house.imageHost + photo"/>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </ion-content>
  <ion-item lines="none" style="box-shadow: 0px -5px 10px #ddd;padding:10px 0 15px;">
    <div slot="start">
      <div style="font-size: 10px">售价</div>
      <div style="color: red; font-size: 20px;font-weight: bold">￥{{ house.price }}<span style="font-size: 13px">万</span></div>
      <ion-label style="font-size: 10px; color: #8F93A0">$ {{ house.audPrice }}万澳元</ion-label>
    </div>
    <div slot="end">
      <ion-button size="large" style="color: #fff" @click="showModal = true">在线咨询</ion-button>
    </div>
  </ion-item>
</opm-page>
</template>

<script type="ts">
import OpmPage from "@/components/OpmPage";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { IonContent, IonItem, IonLabel, IonButton, IonImg, IonIcon, IonGrid, IonRow, IonCol  } from '@ionic/vue';
import { starOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import 'swiper/swiper-bundle.css';
import {useRoute} from "vue-router";

SwiperCore.use([Pagination, Autoplay])
export default defineComponent({
  name: "Project",
  data() {
    return {
      starOutline,
      route: useRoute(),
      house: { tags: '', facilities: '', floorPlans:'', houseImages: '' },
      showModal: false,
      wxShare: {}
    }
  },
  mounted() {
    this.$axios.get(`house/${this.route.params.id}`).then(resp => {
      this.house = resp.result
      document.title = '【鱼掌门App】' +  this.house.district + this.house.address
      const imgUrl = this.house.imageHost + this.house.houseImages.split(',')[0]
      this.wxShare = { title: document.title, desc: document.title, link: location.href, imgUrl: imgUrl }
    })
  },
  methods: {

  },
  components: {
    OpmPage,
    IonContent,
    IonItem,
    IonLabel,
    IonButton,
    IonImg,
    Swiper,
    SwiperSlide,
    IonIcon,
  }
})
</script>

<style scoped>
.tag {
  margin-right: 5px;padding: 3px;font-size:10px;
  border: 1px solid #dedede;
}
.tag.orange {
  border: 0;
  padding: 4px;
  color: #fff; background: #FF640A;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-title{
  font-size: 18px;
  color: #34394E;
}
.room-subtitle {
  font-size: 12px; color: #8F93A0
}
</style>